import React, { createContext, useContext, useState,useEffect } from 'react';
import L from 'leaflet';
export type MapActionType = {
    setView: (lat: number|undefined, lng: number|undefined, zoom: number|undefined) => void;
    setViewToVesselMarker: (vesselId: string, zoom: number) => void;
    openVesselMarkerPopup: (vesselId: string) => void;
    highlightPosition: (position: L.LatLng) => void;
    clickVesselMarker: (vesselId: string) => void;
    clickWarningZoneMarker: (zoneId: string) => void;
    setDraggableCircleRadius: (radius: number) => void;
    setDraggableCirclePosition: (lat: number, lng: number) => void;
    clickDraggableCircle: () => void;
    setDraggableCircleDrag: (draggable: boolean) => void;
};

export type MapDisplayContextType = {
    mapDisplay: 'windy' | 'leaflet';
    setMapDisplay: React.Dispatch<React.SetStateAction<'windy' | 'leaflet'>>;
    action: MapActionType;
    setAction: React.Dispatch<React.SetStateAction<MapActionType>>;
    zoomLevel: number;
    setZoomLevel: React.Dispatch<React.SetStateAction<number>>;
};
const MapDisplayContext = createContext<MapDisplayContextType | undefined>(undefined);


export const MapDisplayProvider: React.FC<{children: React.ReactNode}> = ({ children }) => {
    const [mapDisplay, setMapDisplay] = useState<'windy' | 'leaflet'>('leaflet');
    const [zoomLevel, setZoomLevel] = useState<number>(6);
    const [action, setAction] = useState<MapActionType>({
        setView: () => { alert('chua gan ham'); },
        setViewToVesselMarker: () => { alert('chua gan ham'); },
        openVesselMarkerPopup: () => { alert('chua gan ham'); },
        highlightPosition: () => { alert('chua gan ham'); },
        clickVesselMarker: () => { alert('chua gan ham'); },
        clickWarningZoneMarker: () => { alert('chua gan ham'); },
        setDraggableCircleRadius: () => { alert('chua gan ham'); },
        setDraggableCirclePosition: () => { alert('chua gan ham'); },
        clickDraggableCircle: () => { alert('chua gan ham'); },
        setDraggableCircleDrag: () => { alert('chua gan ham'); },
    });
    return (
        <MapDisplayContext.Provider value={{
            mapDisplay, setMapDisplay, action, setAction, zoomLevel, setZoomLevel
        }}>
            {children}
        </MapDisplayContext.Provider>
    );
};

// Custom hook để sử dụng MapDisplayContext dễ dàng
export const useMapDisplayContext = () => {
    const context = useContext(MapDisplayContext);
    if (!context) throw new Error('useMapDisplayContext must be used within MapDisplayProvider');
    return context;
};